import { Reveal, ClipReveal, Tag, ArrowLink } from "../components/Shared";
import { STORIES } from "../data/content";

const Stories = () => (
  <section className="bg-ink px-5 py-28 sm:px-10 md:py-40" data-testid="stories-section">
    <div className="mx-auto max-w-[1600px]">
      <div className="flex flex-wrap items-end justify-between gap-8">
        <div>
          <Reveal><Tag>Fashion Stories</Tag></Reveal>
          <h2 className="mt-6 font-serif text-5xl font-light tracking-tight sm:text-6xl lg:text-7xl">BEYOND THE <span className="text-fog">COLLECTION</span></h2>
        </div>
        <Reveal><ArrowLink to="/journal" testId="stories-journal-link">Read the Journal</ArrowLink></Reveal>
      </div>

      <div className="mt-20 space-y-24 md:space-y-32">
        {STORIES.map((s, i) => (
          <div key={s.id} className={`grid items-center gap-10 md:grid-cols-12 md:gap-0`} data-testid={`story-${s.id}`}>
            <div className={`md:col-span-7 ${i % 2 ? "md:order-2" : ""}`}>
              <ClipReveal src={s.image} alt={s.title} className="aspect-[16/10]" imgClassName="transition-transform duration-[1.4s] ease-out hover:scale-105" />
            </div>
            <div className={`md:col-span-5 ${i % 2 ? "md:order-1 md:pr-16" : "md:pl-16"}`}>
              <Reveal>
                <span className="font-mono text-sm text-flame">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="mt-4 font-serif text-4xl font-light leading-tight tracking-wide sm:text-5xl">{s.title}</h3>
                <p className="mt-4 text-lg font-light italic text-fog">{s.caption}</p>
                <div className="mt-8">
                  <ArrowLink to="/journal" testId={`story-read-${s.id}`}>Read the Story</ArrowLink>
                </div>
              </Reveal>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Stories;
